import React from 'react';
import { cn } from '@/lib/utils';

// Define possible Nord Card padding sizes based on documentation
type NordCardPadding = 'none' | 's' | 'm' | 'l';

// Define the props for our wrapper component
interface AppNordCardProps {
  padding?: NordCardPadding;
  interactive?: boolean;
  elevated?: boolean;
  href?: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLElement>;
  [key: string]: any; // Allow passing other attributes
}

/**
 * A wrapper around the Nord Design System <nord-card> custom element.
 * Provides type safety and integrates with Tailwind CSS utility functions.
 */
export const AppNordCard: React.FC<AppNordCardProps> = ({
  children,
  padding = 'm',
  interactive,
  elevated,
  href,
  className,
  ...props // Collect remaining props including event handlers
}) => {
  // Combine classes using cn
  const combinedClassName = cn(
    // Add any base classes for styling the wrapper if needed
    className
  );

  // Type assertion to help TypeScript understand the custom element attributes
  const elementProps: any = {
    padding,
    href,
    class: combinedClassName,
    ...props,
  };

  // Add boolean attributes only if they're true (matches Nord UI's API)
  if (interactive) {
    elementProps.interactive = 'true';
  }

  if (elevated) {
    elementProps.elevated = 'true';
  }

  return (
    <nord-card {...elementProps}>
      {children}
    </nord-card>
  );
}; 